/* ================================================================
   MYTHRIL LOGIN - split-screen brand panel injector
   ----------------------------------------------------------------
   Frappe's login DOM has no brand/marketing column. This script
   injects a left-hand brand panel (logo, welcome copy, feature
   badges) on login/signup/forgot pages and flags <body> so the
   scoped CSS in mythril_login.css can lay out the split screen.
   ================================================================ */
(function () {
  var LOGIN_SELECTOR =
    'section.for-login, section.for-email-login, section.for-signup,' +
    ' section.for-forgot, section.for-login-with-email-link';

  function brandMarkup() {
    return [
      '<div class="mlb-top"></div>',
      '<div class="mlb-footer">',
      '  <p class="mlb-location">New-Brunswick, Canada</p>',
      '  <p class="mlb-coords">46°30′N, 66°30′W</p>',
      '</div>'
    ].join('');
  }

  function siteName() {
    var host = (window.location.hostname || "").split(":")[0];
    var label = (host.split(".")[0] || "").trim();
    if (!label || label === "localhost" || label === "www" || /^[0-9.]+$/.test(host)) return "Mythril";
    return label.replace(/[-_]+/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function replaceLoginHeading(section) {
    var heading = section.querySelector('.page-card-head h4');
    if (!heading) return;

    var text = (heading.textContent || '').trim();
    // Frappe's login heading is "Login" (<= v16.25) or "Sign In" (v16.26+).
    // Match either, plus the optional "... to <site>" suffix, so a Frappe
    // upgrade that renames the heading never silently drops our wordmark.
    if (!/^(log\s*in|login|sign\s*in)(\s+to\s+.+)?$/i.test(text)) return;

    heading.classList.add('mythril-logo-heading');
    heading.setAttribute('aria-label', 'Login to ' + siteName());
    heading.innerHTML =
      '<img class="mythril-login-heading-logo" ' +
      'src="/assets/mythril_theme/images/mythril-logo-full.png" alt="" />';

    // v16.26+ renders a small app-logo icon above the heading; hide it so the
    // full wordmark we just injected isn't shown twice.
    var appLogo = section.querySelector('.page-card-head .app-logo');
    if (appLogo) appLogo.style.display = 'none';
  }

  function build() {
    var section = document.querySelector(LOGIN_SELECTOR);
    if (!section || document.querySelector('.mythril-login-brand')) return;

    var brand = document.createElement('aside');
    brand.className = 'mythril-login-brand';
    brand.innerHTML = brandMarkup();
    document.body.appendChild(brand);
    document.body.classList.add('mythril-split-login');

    replaceLoginHeading(section);
  }

  // Drop Frappe's <meta name="generator" content="frappe"> from the DOM on
  // all website pages (the raw HTML source still contains it — removing that
  // entirely would require forking templates/base.html).
  function stripGeneratorMeta() {
    var meta = document.querySelector('meta[name="generator"][content="frappe"]');
    if (meta) meta.remove();
  }

  if (document.readyState !== 'loading') {
    build();
    stripGeneratorMeta();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      build();
      stripGeneratorMeta();
    });
  }
})();
